import * as React from "react";

// gradient-card imports

// material-ui
import { Button } from "@clockwise/design-system";
import { Close, NavigateNext } from "@clockwise/design-system/icons";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import classNames from "classnames";

export interface IProps {
  cardStyle?: CSSProperties;
  hideDismissButton?: boolean;
  isDismissed?: boolean;
  rounded?: boolean;
  href?: string;
  buttonLabel: string;
  label: string;
  onDismiss?: () => void;
  onClick?: () => void;
}

///////////////
// Component //
///////////////
export const GradientCard = ({
  hideDismissButton,
  isDismissed,
  rounded = false,
  href,
  buttonLabel,
  label,
  onDismiss,
  onClick,
}: IProps) => {
  const [dismissedPromotion, setDismissedPromotion] = React.useState(!!isDismissed);

  const onDismissPromotion = () => {
    setDismissedPromotion(true);
    onDismiss?.();
  };

  if (dismissedPromotion) {
    return null;
  }

  const handleClick = () => {
    if (href) {
      window.open(href, "_blank");
    }
    onClick?.();
  };

  return (
    <div
      className={classNames(
        "cw-relative cw-hidden md:cw-flex cw-items-center cw-gap-4 cw-p-4 cw-text-onEmphasis cw-bg-brand-emphasis",
        {
          "cw-rounded": rounded,
          "cw-pr-10": !hideDismissButton,
        },
      )}
    >
      {!hideDismissButton && (
        <Close
          className="cw-w-6 cw-h-6 cw-absolute cw-right-2 cw-top-2 cw-cursor-pointer"
          onClick={onDismissPromotion}
        />
      )}
      <div className={"cw-heading-xl cw-text-onEmphasis"}>{label}</div>
      <Button
        rounded
        variant="outlined"
        sentiment="positive"
        onClick={handleClick}
        endIcon={NavigateNext}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};
